<template>
  <div class="animated fadeIn">
    <div class="title font-300 font-24 mb-15">Create Lead</div>
    <div class="box">
      <div class="p-20 pb-0">
        <div class="row">
          <div class="col-6">
            <a @click="openPage('/leads')" class="link-back">
              <i class="fas fa-arrow-circle-left mr-5"></i>Back
            </a>
          </div>
        </div>
      </div>
      <hr class="mb-0" />
      <div class="p-20 pt-0">
        <form @submit.prevent="validateRegister">
          <div class="font-bold mt-20">Lead Information</div>
          <hr class="short-line left" />
          <div class="row mb-30">
            <div class="col-lg-6">
              <b-row class="mb-20">
                <b-col sm="3">
                  <div class="label-name">Branch</div>
                </b-col>
                <b-col sm="9">
                  <b-form-select class="form-control border-bottom" name="branch" v-model="branch_id"
                    @change="changeBranch">
                    <option :value="null">Please select</option>
                    <option v-for="item in dataBranch" :key="item.id" :value="item.id">{{ item.name }}</option>
                  </b-form-select>
                </b-col>
              </b-row>

              <b-row class="mb-20">
                <b-col sm="3">
                  <div class="label-name">Lead Owner</div>
                </b-col>
                <b-col sm="9">
                  <template
                    v-if="checkSessionRoleId === '4' || getRoleId == '17' || getRoleId == 17 || getRoleId == '6' || getRoleId == 6">
                    <b-form-select name="lead_owner" v-validate="'required'" v-model="addData.owner_id"
                      class="form-control border-bottom">
                      <option value="null">Please select</option>
                      <option v-for="item in itemSales" :key="item.id" :value="item.id">{{ item.fullname }}</option>
                    </b-form-select>
                    <span class="error">{{ errors.first('lead_owner') }}</span>
                  </template>
                  <template v-else>
                    <b-form-select name="lead_owner" v-validate="'required'" disabled v-model="addData.owner_id"
                      class="form-control border-bottom bg-transparent">
                      <option value="null">Please select</option>
                      <option v-for="item in itemSales" :key="item.id" :value="item.id">{{ item.fullname }}</option>
                    </b-form-select>
                    <span class="error">{{ errors.first('lead_owner') }}</span>
                  </template>
                </b-col>
              </b-row>
              <b-row class="mb-20">
                <b-col sm="3">
                  <label>Refferal Member</label>
                </b-col>
                <b-col sm="9">
                  <div class="custom-search-select">
                    <model-select autocomplete="false" :options="optionsMember"
                      @searchchange="searchMemberWithoutBranch" class="border-bottom" placeholder="Select member"
                      name="member_id" v-model="addData.member_id"></model-select>
                  </div>
                </b-col>
              </b-row>
              <b-row class="mb-20">
                <b-col sm="3">
                  <div class="label-name">Refferal PT</div>
                </b-col>
                <b-col sm="9">
                  <b-form-select name="refferal_pt_id" v-model="addData.referral_pt_id"
                    class="form-control border-bottom">
                    <option value="null">Please select</option>
                    <option v-for="item in itemsPT" :key="item.id" :value="item.id">{{ item.name }}</option>
                  </b-form-select>
                </b-col>
              </b-row>
              <b-row class="mb-20">
                <b-col sm="3">
                  <div class="label-name">Lead Source</div>
                </b-col>
                <b-col sm="9">
                  <b-form-select name="lead_source" v-validate="'required'" v-model="addData.source_type_id"
                    class="form-control border-bottom">
                    <option value="null">Please select</option>
                    <option v-for="item in itemSource" :key="item.id" :value="item.id">{{ item.name }}</option>
                  </b-form-select>
                  <span class="error">{{ errors.first('lead_source') }}</span>
                </b-col>
              </b-row>
              <b-row class="mb-20">
                <b-col sm="3">
                  <div class="label-name">First Name</div>
                </b-col>
                <b-col sm="9">
                  <b-form-input class="form-control border-bottom" v-model="addData.first_name" name="first_name"
                    v-validate="'required'" type="text"></b-form-input>
                  <span class="error">{{ errors.first('first_name') }}</span>
                </b-col>
              </b-row>
              <b-row class="mb-20">
                <b-col sm="3">
                  <div class="label-name">Last Name</div>
                </b-col>
                <b-col sm="9">
                  <b-form-input class="form-control border-bottom" v-model="addData.last_name" name="last_name"
                    v-validate="'required'" type="text"></b-form-input>
                  <span class="error">{{ errors.first('last_name') }}</span>
                </b-col>
              </b-row>
              <b-row class="mb-20">
                <b-col sm="3">
                  <div class="label-name">Email</div>
                </b-col>
                <b-col sm="9">
                  <b-form-input class="form-control border-bottom" name="email" v-validate="'required|email'"
                    v-model="addData.email" type="text"></b-form-input>
                  <span class="error">{{ errors.first('email') }}</span>
                </b-col>
              </b-row>
              <b-row class="mb-20">
                <b-col sm="3">
                  <div class="label-name">ID Card</div>
                </b-col>
                <b-col sm="9">
                  <b-form-input class="form-control border-bottom" name="no_ktp" v-validate="'required|numeric'"
                    v-model="addData.no_ktp" type="text"></b-form-input>
                  <span class="error">{{ errors.first('no_ktp') }}</span>
                </b-col>
              </b-row>
            </div>
            <div class="col-lg-6">
              <b-row class="mb-20">
                <b-col sm="3">
                  <div class="label-name">Phone Number</div>
                </b-col>
                <b-col sm="3">
                  <model-select autocomplete="false" :options="optionCountryCode"
                      @searchchange="onCountryCode" class="border-bottom" placeholder="country code"
                      name="country_code" v-model="addData.phone_country_code"></model-select>
                </b-col>
                <b-col sm="6">
                  <b-form-input class="form-control border-bottom" name="phone_number" v-model="addData.phone_number"
                    v-validate="'regex:^[1-9][0-9]*$'" type="text" @blur="normalizePhoneNumber('phone_number')"></b-form-input>
                  <span class="error">{{ errors.first('phone_number') }}</span>
                </b-col>
              </b-row>
              <b-row class="mb-20">
                <b-col sm="3">
                  <div class="label-name">Home Number</div>
                </b-col>
                <b-col sm="9">
                  <b-form-input class="form-control border-bottom" v-validate="'numeric'" name="home_number"
                    v-model="addData.home_number" type="text"></b-form-input>
                  <span class="error">{{ errors.first('home_number') }}</span>
                </b-col>
              </b-row>
              <b-row class="mb-20">
                <b-col sm="3">
                  <div class="label-name">Birthday</div>
                </b-col>
                <b-col sm="9">
                  <flat-pickr :config="config" v-model="addData.birthday" class="w-100"></flat-pickr>
                </b-col>
              </b-row>
              <b-row class="mb-20">
                <b-col sm="3">
                  <div class="label-name">Gender</div>
                </b-col>
                <b-col sm="9">
                  <b-form-radio-group id="radios2" v-model="addData.gender" name="gender">
                    <b-form-radio class="font-13" value="1">Male</b-form-radio>
                    <b-form-radio class="font-13" value="2">Female</b-form-radio>
                  </b-form-radio-group>
                </b-col>
              </b-row>
              <b-row class="mb-20">
                <b-col sm="3">
                  <div class="label-name">Address</div>
                </b-col>
                <b-col sm="9">
                  <b-form-input class="form-control border-bottom" name="address" v-model="addData.address"
                    type="text"></b-form-input>
                </b-col>
              </b-row>

              <b-row class="mb-20">
                <b-col sm="3">
                  <div class="label-name">Current Address</div>
                </b-col>
                <b-col sm="9">
                  <b-form-input class="form-control border-bottom" name="current_address"
                    v-model="addData.current_address" type="text"></b-form-input>
                </b-col>
              </b-row>
            </div>
          </div>
          <div class="font-bold mt-20">Lead Emergency Information</div>
          <hr class="short-line left" />
          <div class="row mb-20">
            <div class="col-lg-6">
              <b-row class="mb-20">
                <b-col sm="3">
                  <div class="label-name">Emergency Contact</div>
                </b-col>
                <b-col sm="9">
                  <b-form-input class="form-control border-bottom" name="emergency_contact"
                    v-model="addData.emergency_contact" type="text"></b-form-input>
                </b-col>
              </b-row>
              <b-row class="mb-20">
                <b-col sm="3">
                  <div class="label-name">Emergency Number</div>
                </b-col>
                <b-col sm="9">
                  <b-form-input class="form-control border-bottom" name="emergency_number"
                    v-model="addData.emergency_number" type="text"></b-form-input>
                </b-col>
              </b-row>
            </div>
          </div>
          <div class="font-bold mt-20">Credit Card</div>
          <hr class="short-line left" />
          <div class="row mb-20">
            <div class="col-lg-6">
              <b-row class="mb-20">
                <b-col sm="3">
                  <div class="label-name">Credit Card Holder Name</div>
                </b-col>
                <b-col sm="9">
                  <b-form-input class="form-control border-bottom" v-model="addData.credit_card_holder_name"
                    name="credit_card_holder_name" type="text"></b-form-input>
                </b-col>
              </b-row>
              <b-row class="mb-20">
                <b-col sm="3">
                  <div class="label-name">Credit Card Number</div>
                </b-col>
                <b-col sm="9">
                  <b-form-input class="form-control border-bottom bg-transparent"
                    v-model="addData.credit_card_number" name="credit_card_number" type="text"></b-form-input>
                </b-col>
              </b-row>
              <b-row class="mb-20">
                <b-col sm="3">
                  <div class="label-name">Credit Card Bank Name</div>
                </b-col>
                <b-col sm="9">
                  <b-form-input class="form-control border-bottom" v-model="addData.credit_card_bank_name"
                    name="credit_card_bank_name" type="text"></b-form-input>
                </b-col>
              </b-row>
              <b-row class="mb-20">
                <b-col sm="3">
                  <div class="label-name">Credit Card Type</div>
                </b-col>
                <b-col sm="9">
                  <b-form-select name="credit_card_type" class="form-control border-bottom bg-transparent"
                    v-model="addData.credit_card_type">
                    <option value="VISA">VISA</option>
                    <option value="Mastercard">Mastercard</option>
                  </b-form-select>
                </b-col>
              </b-row>
              <b-row class="mb-20">
                <b-col sm="3">
                  <div class="label-name">Credit Card Month Expired</div>
                </b-col>
                <b-col sm="9">
                  <b-form-select name="credit_card_month_expired" class="form-control border-bottom"
                    v-model="addData.credit_card_month_expired">
                    <option value="01">01</option>
                    <option value="02">02</option>
                    <option value="03">03</option>
                    <option value="04">04</option>
                    <option value="05">05</option>
                    <option value="06">06</option>
                    <option value="07">07</option>
                    <option value="08">08</option>
                    <option value="09">09</option>
                    <option value="10">10</option>
                    <option value="11">11</option>
                    <option value="12">12</option>
                  </b-form-select>
                </b-col>
              </b-row>
              <b-row class="mb-20">
                <b-col sm="3">
                  <div class="label-name">Credit Card Year Expired</div>
                </b-col>
                <b-col sm="9">
                  <b-form-input class="form-control border-bottom bg-transparent"
                    v-model="addData.credit_card_year_expired" name="credit_card_year_expired" type="text"></b-form-input>
                </b-col>
              </b-row>
            </div>
          </div>
          <div class="text-right">
            <button type="submit" class="btn-primary">Submit</button>
          </div>
        </form>
      </div>
    </div>

    <!-- Loading -->
    <div v-if="loadingActive == true" class="loading-container">
      <div class="wrap-screen w-100 h-100">
        <img :src="`/svg-loaders/oval.svg`" width="60" alt="" />
        <div class="title-loading color-white">Loading...</div>
      </div>
    </div>
  </div>
</template>

<script>
import { Callout } from "@coreui/vue";
import axios from "axios";
import { Auth } from "@/api";

import { ModelSelect } from "vue-search-select";
import Mixin from '../../mixins/memberMixin'

export default {
  name: "addLeads",
  components: {
    ModelSelect
  },
  mixins: [Mixin],
  data: function () {
    return {
      loadingActive: false,
      config: {},
      itemSales: [],
      itemSource: [],
      dataBranch: [],
      itemCountryCodes: [],
      optionCountryCode: [],
      itemsPT: [],
      optionsMember: [{ value: null, text: 'Please select' }],
      branch_id: null,
      checkSessionRoleId: "",
      getRoleId: Auth.Session.get().paradigm_role,
      addData: {
        owner_id: null,
        source_type_id: null,
        member_id: null,
        first_name: "",
        last_name: "",
        email: "",
        no_ktp: "",
        phone_country_code: "+62",
        phone_number: "",
        home_number: "",
        birthday: "01/01/2018",
        gender: "",
        address: "",
        current_address: "",
        emergency_contact: "",
        emergency_number: "",
        referral_pt_id: null,
        credit_card_holder_name: "",
        credit_card_number: "4811111111111114",
        credit_card_bank_name: "",
        credit_card_type: "VISA",
        credit_card_month_expired: "",
        credit_card_year_expired: "27"
      },
      options: [
        { value: null, text: "Please select" },
        { value: "active", text: "Active" },
        { value: "inactive", text: "Inactive" }
      ]
    };
  },
  methods: {
    changeBranch(event) {
      this.fetchData()
    },
    validateRegister() {
      console.log("this.addData", this.addData);
      this.$validator.validateAll().then(result => {
        if (result) {
          this.loadingActive = true
          axios.defaults.headers.common[
            "X-Access-Token"
          ] = Auth.Session.get().paradigm_token;
          axios
            .post("crm/v1/leads", this.addData)
            .then(response => {
              this.loadingActive = false
              this.$router.push("/leads");
              this.$toast.success("data saved successfully!", "Success", {
                position: "topCenter",
                icon: "icon-envelope",
                progressBarColor: "rgb(0, 255, 184)",
                theme: "dark",
                backgroundColor: "#565c70",
                messageColor: "#fff"
              });
            })
            .catch(error => {
              this.loadingActive = false
              console.log("error", error.response);
              // console.log('error', error.response.data.error)
              if (error.response.data) {
                this.$toast.success(error.response.data.error, "Error", {
                  position: "topCenter",
                  icon: "icon-envelope",
                  progressBarColor: "rgb(0, 255, 184)",
                  theme: "dark",
                  backgroundColor: "#565c70",
                  messageColor: "#fff"
                });
              } else {
                this.$toast.success("Cant saved data!", "Error", {
                  position: "topCenter",
                  icon: "icon-envelope",
                  progressBarColor: "rgb(0, 255, 184)",
                  theme: "dark",
                  backgroundColor: "#565c70",
                  messageColor: "#fff"
                });
              }
            });
        } else {
          this.$toast.success("please fill in required fields!", "Error", {
            position: "topCenter",
            icon: "icon-envelope",
            progressBarColor: "rgb(0, 255, 184)",
            theme: "dark",
            backgroundColor: "#565c70",
            messageColor: "#fff"
          });
        }
      });
    },
    openPage(event) {
      this.$router.push(event);
    },
    previewImage: function (event) {
      // Reference to the DOM input element
      var input = event.target;
      // Ensure that you have a file before attempting to read it
      if (input.files && input.files[0]) {
        // create a new FileReader to read this image and convert to base64 format
        var reader = new FileReader();
        // Define a callback function to run, when FileReader finishes its job
        reader.onload = e => {
          // Note: arrow function used here, so that "this.imageData" refers to the imageData of Vue component
          // Read image as base64 and set to imageData
          this.imageData = e.target.result;
        };
        // Start the reader job - read file as a data url (base64 format)
        reader.readAsDataURL(input.files[0]);
      }
    },
    onCountryCode(event) {
      console.log("event", event);
    },
    normalizePhoneNumber(field) {
      // Country code +62 sudah dipilih terpisah di dropdown, jadi field ini harus
      // nomor nasional TANPA 0 di depan (bukan "0812...", tapi "812...").
      const raw = this.addData[field]
      if (!raw) return
      let cleaned = `${raw}`.replace(/[^0-9+]/g, '')
      if (cleaned.startsWith('+62')) {
        cleaned = cleaned.slice(3)
      } else if (cleaned.startsWith('62') && cleaned.length > 9) {
        cleaned = cleaned.slice(2)
      }
      cleaned = cleaned.replace(/\+/g, '')
      cleaned = cleaned.replace(/^0+/, '')
      if (cleaned !== raw) {
        this.addData[field] = cleaned
      }
    },
    fetchData() {
      // branch
      axios.get('fitness/v1/branch/').then(response => {
        this.dataBranch = response.data.data.rows
      }).catch(error => {
        console.log('error', error)
      })

      // axios
      //   .get("crm/v1/leads")
      //   .then(response => {
      //     this.items = response.data.data.rows;
      //   })
      //   .catch(error => {
      //     console.log("error", error);
      //   });
      if (Auth.Session.get().paradigm_role === "1") {
        axios
          .get("crm/v1/sales")
          .then(response => {
            this.itemSales = response.data.data.rows;
          })
          .catch(error => {
            console.log("error", error);
          });
      } else {
        axios
          .get(
            "crm/v1/sales/my_sales/" +
            Auth.Session.get().paradigm_id +
            "?status=active&sorting=fullname&sorting_type=asc&branch_id=" +
            this.branch_id
          )
          .then(response => {
            this.itemSales = response.data.rows;
          })
          .catch(error => {
            console.log("error", error);
          });
      }
      axios
        .get("crm/v1/leads_source_type?status=active")
        .then(response => {
          this.itemSource = response.data.data.rows;
        })
        .catch(error => {
          console.log("error", error);
        });

      axios
        .get("crm/v1/country_code")
        .then(response => {
          // this.optionCountryCode = response.data.data;
          // console.log("optionCountryCode", response.data.data);
          this.optionCountryCode = [];
          for (let i = 0; i < response.data.data.length; i++) {
            const el = response.data.data[i];
            this.optionCountryCode.push({
              value: el.dial_codes,
              text: el.dial_codes + "  " + el.emoji + " " +  el.name
            });

          }
        })
        .catch(error => {
          console.log("error", error);
        });

      axios
        .get(
          "fitness/v1/personal_training?status=active&sorting=name&sorting_type=asc&branch_id=" + this.branch_id)
        .then((response) => {
          this.itemsPT = response.data.data.rows;
        })
    }
  },
  created() {
    this.checkSessionRoleId = Auth.Session.get().paradigm_role;
    if (Auth.Session.get().paradigm_role === "4") {
      this.addData.owner_id = null;
    } else {
      this.addData.owner_id = Auth.Session.get().paradigm_id;
    }

    this.branch_id = Auth.Session.get().paradigm_branch_id
    this.fetchData();
  }
};
</script>

<style></style>
